module.exports = __webpack_public_path__ + "static/109_home-f6e54c3f154a0d28380f81e64307ce5e.png";